import Controller from '../comment_controller'
export default Controller